// /ServiceRecord/index.js
import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ArrowLeftOutlined, PrinterOutlined } from "@ant-design/icons";
import { App, Button, Card, Flex, Grid, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import ServiceRecordFilters from "./components/ServiceRecordFilters";
import ServiceRecordTable from "./components/ServiceRecordTable";
import { fetchServiceRecord } from "./ServiceRecordThunk";
import ReportDom from "../../../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";

const { Title } = Typography;

const ServiceRecord = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  // 👇 pull data safely (avoid destructuring undefined)
  const serviceRecordState = useSelector((state) => state.serviceRecord) || {};
  const { filters = {}, list = [] } = serviceRecordState;

  useEffect(() => {
    dispatch(fetchServiceRecord({})); // initial load
  }, [dispatch]);

  const reportRef = useRef(null);

  const handlePrint = useReactToPrint({
    contentRef: reportRef,    
    documentTitle: "Service Report",
    removeAfterPrint: true, // cleanup after printing
  });

  return (
    <div className="p-4">
      <App>        
        <Card data-testid="service-voucher-card"
          className="shadow-md rounded-xl mb-4"
          title={
            <Flex align="center">
              <Button
                type="text"
                icon={<ArrowLeftOutlined style={{ fontSize: 18 }} />}
                onClick={() => navigate(-1)}
                style={{ marginRight: 8, padding: 0, height: "auto", lineHeight: "1", color: "#000" }}
                data-testid="service-record-back-button"
              />
              <Title level={4} style={{ margin: 0 }}>Service Record</Title>
            </Flex>
          }
          extra={
            <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
              { !screens.xs && "Print" }
            </Button>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },  
            body: { padding: 0 },                                    
          }}
        />

        <ServiceRecordFilters messageApi={message} />
        <Card className="shadow-md rounded-xl">
          <ServiceRecordTable />
        </Card>
      </App>
      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
          <ReportDom
            ref={reportRef}
            title="Service Report"
            filters={filters}
            // columns={columns}
            // data={list}
            renderTable={() => (
            <ServiceRecordTable pagination={false} printMode={true}/>   /* ✅ reuse your actual table */
            )}
          />
      </div>
    </div>
  );
};

export default ServiceRecord;
